module.exports = __webpack_public_path__ + "img/T05.751a22a0.jpg";